import CompaniesPageView from "./CompaniesPageView";

function CompaniesPage() {
  return <CompaniesPageView />;
}

export default CompaniesPage;
